import {
  lesson6Assignment1,
  lesson6Assignment2,
  lesson6Assignment3,
} from './assignments'
import { createChessboard } from '../../utils'
import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_6/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_6/1.mp3', start: true, controls: false },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Take two moves to <br/>get the Rook from <br/>c2 to e6. Then from <br/>e6 to a7.`,
      timeout: 13000
    },
    chessboard: {
      board: lesson6Assignment1({
        showIndicators: { allSides: true },
        prefilledCoordinates: ['.square-e6', '.square-a7'],
        position: '8/8/8/8/8/8/2R5/8',
        next: 2
      }),
      positionFen: '8/8/8/8/8/8/2R5/8 w - - 0 1',
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_6/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    text: {
      data: 'Remember, <br/>you must capture a piece on every move!',
      position: 'left',
      styleClass: 'lg',
      timeout: 11000
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the Rook, <br/>then drag him <br/>to the piece <br/>you want him <br/>to capture.`,
      timeout: 10000
    },
    audio: { src: 'img/audio/lesson_6/2.mp3', start: true, controls: false },
    chessboard: {
      board: lesson6Assignment2({
        showIndicators: { allSides: true },
        position: '8/3p4/1p2n3/3p2b1/4p3/8/1R6/4b1n1',
        assignmentClass: 'custom-sparepiece',
        next: 4
      }),
      positionFen: '8/3p4/1p2n3/3p2b1/4p3/8/1R6/4b1n1 w - - 0 1',
    }
  },
  {
    id: 4,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_6/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5,
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    text: {
      data: "Here's a hint...<br/>the White King is the last piece you will capture.",
      position: 'left',
      styleClass: 'lg',
      timeout: 2000
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the Rook, <br/>then drag him to <br/>the piece you want <br/>him to capture. <br/>Remember, if you <br/>take a wrong turn, <br/>you will hit <br/>a dead end.`,
      timeout: 1000
    },
    chessboard: {
      board: lesson6Assignment3({
        showIndicators: { allSides: true },
        position: '8/3P1K2/2P3rP/8/8/P1P2P2/3P1P2/8',
        assignmentClass: 'custom-sparepiece',
        next: 6
      }),
      positionFen: '8/3P1K2/2P3rP/8/8/P1P2P2/3P1P2/8 b - - 0 1',
    }
  },
  {
    id: 6,
    previous: 4,
    next: 7,
    video: {
      src: 'img/videos/lesson_6/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 7,
    }
  },
  {
    id: 7,
    previous: 4,
    next: 8,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "What does the Rook resemble from the Middle Ages?",
      answer: [
        'The whole castle',
        'The castle moat',
        'The castle fence',
        'The castle tower'
      ],
      rightAnswer: 'The castle tower',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 8,
    previous: 4,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "How many points is the Rook worth?",
      answer: [
        '1',
        '3',
        '5',
        '7'
      ],
      rightAnswer: '5',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 9,
    previous: 4,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: "What is the Rook's symbol?",
      answer: [
        'RK',
        'R',
        "r",
        '#'
      ],
      rightAnswer: 'R',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md',
    }
  },
  {
    id: 10,
    previous: 4,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "Where do the Rooks stand at the start of the game?",
      answer: [
        'The a and h files',
        'The b and g files',
        'The c and f files',
        'The d and e files'
      ],
      rightAnswer: 'The a and h files',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 4,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: "How does the Rook move?",
      answer: [
        'Only on files',
        'Only on ranks',
        'On both files and ranks',
        'On diagonals'
      ],
      rightAnswer: 'On both files and ranks',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 4,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'How many squares could this Rook move to from his position on d4?',
      answer: [
        '12',
        '14',
        '16',
        '18'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/8/8/8/3R4/8/8/8'
        }),
        hint: true
      },
      rightAnswer: '14',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 4,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    chessboard: {
      board: highlightCoordinates({
        isQA: true,
        showIndicators: { allSides: true },
        coordinates: ['.square-a8', '.square-b8', '.square-c8', '.square-d8', '.square-e7', '.square-f8'],
        position: '4r1k1/pp3pp1/4p2p/8/8/3P2P1/PP2PPK1/2R5',
        celebrationSound: false,
        coordinateClass: 'filled-square',
        reminder: true,
      }),
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on all the <br/>squares the <br/>Black Rook on e8 <br/>could move to.`
    }
  },
  {
    id: 14,
    previous: 4,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'How does the Rook capture?',
      answer: [
        'Along a file or rank',
        'Along a diagonal',
        'By moving backwards',
        'By jumping over a piece'
      ],
      rightAnswer: 'Along a file or rank',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 4,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    chessboard: {
      board: highlightCoordinates({
        isQA: true,
        showIndicators: { allSides: true },
        coordinates: ['.square-b4', '.square-e3'],
        position: '8/8/8/8/1P2r1pP/3RP1P1/4N3/8',
        celebrationSound: false,
        coordinateClass: 'filled-square',
        reminder: true,
      }),
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the pieces <br/>the Black Rook <br/>could capture.`
    }
  },
  {
    id: 16,
    previous: 4,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    chessboard: {
      board: highlightCoordinates({
        isQA: true,
        showIndicators: { allSides: true },
        coordinates: ['.square-e6', '.square-g4', '.square-c6'],
        position: '4r1k1/1p3pp1/pBn1r3/7p/4R1b1/3P2P1/PP2PPK1/2R5',
        celebrationSound: false,
        coordinateClass: 'filled-square',
        reminder: true,
      }),
    },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on all the <br/>pieces the <br/>White Rooks <br/>could capture.`
    }
  },
  {
    id: 17,
    previous: 4,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Seven',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_5.png',
  '/img/background_6.png',
  '/img/background_7.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_6/index.js